import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('disability_benefits_set', '/disability_benefits_sets', 'benefits_set')
const actions = generator.generate()

export default actions
